import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';
// import { getVistaPresupuestosInternosList, getVistaPresupuestosInternosAbiertosList } from '../../helpers/user_mv';

const state = {
    certificados: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    filtroPeriodo: true,
    filtroNumero: false,
    filtroPresupuesto: false,
    fechaDesde: moment(new Date()).add(-30, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    numero: 0,
    cliente: null,
    contacto: null,
    numeroPO: '',
    numeroPI: 0,
    clienteFacturacion: null,
    sortByDescending: true,
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.certificados = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.filtroPeriodo = true;
        state.filtroNumero = false;
        state.filtroPresupuesto = false;
        state.fechaDesde = moment(new Date()).add(-30, 'days').format('YYYY-MM-DD');
        state.fechaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.numero = 0;
        state.cliente = null;
        state.contacto = null;
        state.numeroPO = '';
        state.numeroPI = 0;
        state.clienteFacturacion = null;
        state.sortByDescending = true;
    },

    'INICIALIZAR_CERTIFICADOS' (state) {
        state.certificados = [];
    },
    'SET_CERTIFICADOS' (state, certificados) {
        state.certificados = certificados.map( certificado => ({ 
            ...certificado, 
            _rowVariant: certificado.importeFacturado == 0 ? 'danger' : ''  
        }) );
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
        
    getCertificados ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CERTIFICADOS');

            let queryString = '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual;

            if ((/true/i).test(state.filtroNumero)) {
                if (state.numero != 0) {
                    queryString += '&numero=' + state.numero;
                } else {
                    queryString += '&numero=-1';
                }
            } else if ((/true/i).test(state.filtroPresupuesto)) {
                if (state.numeroPI != 0) {
                    queryString += '&presupuestoNumero=' + state.numeroPI;
                }
                if (state.numeroPO.trim() != '') {
                    queryString += '&numeroOrdenCompra=' + state.numeroPO.trim();
                }
                if (state.numeroPI == 0 & state.numeroPO.trim() == '') {
                    queryString += '&presupuestoNumero=-1';
                }
            } else {
                queryString += '&fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                    + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                    + '&sortByDescending='+ state.sortByDescending;

                if (state.cliente) {
                    if (state.cliente.id != 0) {
                        queryString += '&clienteId=' + state.cliente.id;
                    }
                }
                if (state.contacto) {
                    if (state.contacto.id != 0) {
                        queryString += '&contactoId=' + state.contacto.id;
                    }
                }
                if (state.clienteFacturacion) {
                    if (state.clienteFacturacion.id != 0) {
                        queryString += '&clienteFacturacionId=' + state.clienteFacturacion.id;
                    }
                }
            }
                
            apiAxios.get('certificadosservicio' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }

                    commit('SET_CERTIFICADOS', res.data);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    cancelar ( {}, params ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('certificadosservicio/' + params.certificadoId + '/cancelar', params)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
    delete ( {}, certificadoId ) {
        return new Promise((resolve, reject) => {
            apiAxios.post('certificadosservicio/' + certificadoId + '/delete')
            .then(() => resolve())
            .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}